<template>
    <div class="menuButton" @click="select">
        <img :src="selected ?icons[1]:icons[0]" alt="">
        <div :class="selected?'show':'title'">
            {{title}}
        </div>
    </div>
</template>

<script>
export default {
    props:{
        title:String,
        icons:Array,
        selected:Boolean,
    },
    data(){
        return {
        }
    },
    computed:{
    },
    watch:{
        selected(flag){
            if(flag){
                let _this = this
                setTimeout(() => {
                    _this.$emit('on')
                }, 100);

            }else{
                this.$emit('off')
            }
        },
    },
    mounted(){
        

    },
    methods:{
        select(){
            this.$emit("click")
        }
    }
}
</script>

<style lang="less" scoped>
    .menuButton{
        width: 3vw;
        height: 5.7vh;
        display: flex;
        flex-direction: column;
        text-align: center;
        cursor: pointer;
        img{
            width: 3vw;
            height: 3vw;
        }
        .title{
            display: none;
            color: #fff;
            font-size: 14rem;
            margin-top: -7rem;
            text-shadow: 0 0 8rem #0D94FF,0 0 8rem #0D94FF,0 0 8rem #0D94FF;
        }
        .show{
            display: block;
            color: #fff;
            font-size: 14rem;
            margin-top: -7rem;
            text-shadow: 0 0 8rem #0D94FF,0 0 8rem #0D94FF,0 0 8rem #0D94FF;
        }
        &:hover .title{
            display: block;
        }
    }
</style>